import type { SVGProps } from "react";
const SvgArrowLeft02Sharp1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 12h15M9 7l-4.293 4.293c-.333.333-.5.5-.5.707s.167.374.5.707L9 17"
    />
  </svg>
);
export default SvgArrowLeft02Sharp1;
